import type { ComponentProps } from 'react';
import { Image } from '@belong/ui';
import clsx from 'clsx';
import { GttlCoverContent } from 'src/features/homeowners/components/gttl-landing-page/components/gttl-cover/gttl-cover';
import { getCdnListingSrc } from 'src/utils/get-cdn-listing-src';
import css from './city-cover.module.css';

type Props = Pick<ComponentProps<typeof Image>, 'src'> & {
  cityName: string;
  phoneNumber?: string;
};

export function CityCover({ phoneNumber, src, cityName }: Props) {
  return (
    <div
      className="bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url("${getCdnListingSrc(src)}")` }}
    >
      <div
        className={clsx(
          'pt-3xl flex flex-col items-center text-center',
          css.coverContainer,
        )}
      >
        <GttlCoverContent city={cityName} phoneNumber={phoneNumber} />
      </div>
    </div>
  );
}
